import React from 'react';

class BlackBox extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    let { className, children, content, color = 'black' } = this.props;
    className = `BlackBox ${className ? ' ' + className : ''} BlackBox-${color}`;

    content = (typeof content === 'string')
      ? <div dangerouslySetInnerHTML={{ __html: content }} />
      : content;

    return (
      <div className={className}>
        {content}
        {children}
      </div>
    );
  }
};

export default BlackBox;



// WEBPACK FOOTER //
// ./client/Core/Components/BlackBox.jsx